import { ProfileAdminRules, ProfileAdminSettings, Rules } from "../features/admin/admin.model"
import { inject, Injectable } from "@angular/core";
import { UserStore, UserStoreType } from "app/features/user/store/user.store";
import { FormGroup } from "@angular/forms";

export enum RuleType {
    PAYMENT_METHOD_ACCOUNT_TYPE = 'paymentMethod.accountType'
}

@Injectable({
    providedIn: 'root'
})
export class RulesService {
    private rules: ProfileAdminRules;
    private userStore: UserStoreType = inject(UserStore);

    constructor() {
    }   

    evaluateRules(context: any): number | null {
        const activeProfile = this.userStore.activeProfile();
        const rules = activeProfile?.profileDetail?.profileAdminSettings?.profileAdminRules?.rules;
        if (!rules?.length) return null;
        
        for (const rule of rules) {
            if (rule.type === RuleType.PAYMENT_METHOD_ACCOUNT_TYPE && 
                context.paymentMethod?.accountType) {
                if (this.evaluateCondition(rules, context.paymentMethod.accountType)) {
                    console.log('check3', context.paymentMethod);
                    return this.executeAction(rule);
                }
            }
        }
        return null;
    }

    private evaluateCondition(rules: any, accountType: string): boolean {
        // Handle equality comparisons
        rules.find((r: any) => 
            r.type === 'paymentMethod.accountType' && 
            r.if === accountType &&
            r.then.split('=')[0].trim() === 'costOfCapitalPercent'
        );

        return false;
    }

    private executeAction(rule: any): number | null {
        if (rule.type === RuleType.PAYMENT_METHOD_ACCOUNT_TYPE) {
            const [, value] = rule.then.split('=').map((s: string) => s.trim());
            return Number(value);
        }
        return null;
    }

    paymentMethodToCostOfCapitalRule(accountType: string | undefined): number | null {
        const activeProfile = this.userStore.activeProfile();
        const rules = activeProfile?.profileDetail?.profileAdminSettings?.profileAdminRules?.rules;
        
        if (!rules?.length || !accountType) return null;

        const rule = rules.find(r => 
            r.type === 'paymentMethod.accountType' && 
            r.if === accountType &&
            r.then.split('=')[0].trim() === 'costOfCapitalPercent'
        );

        if (rule) {
            const [, value] = rule.then.split('=').map((s: string) => s.trim());
            return Number(value);
        }

        return null;
    }
}